function AllProjects() {
  return (
    <h1>All projects</h1>
  )
}

export default AllProjects;
